import React from 'react';
import AdminDiscountForm from '../../AdminDiscountForm';

const BulkOrderDiscountModal = ({
  show,
  onClose,
  selectedCount,
  forceDiscount,
  onForceDiscountChange,
  discountLevelsList,
  selectedDiscountLevel,
  onDiscountLevelChange,
  discountPercent,
  onDiscountPercentChange,
  token,
  discountSelectedUser,
  discountUserSearchQuery,
  onDiscountUserSearchQueryChange,
  onDiscountUserSelect,
  onDiscountUserClear,
  onApply,
  loading,
  message,
  errorMessage,
}) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
        onClick={() => !loading && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header align-items-center py-2">
              <div>
                <h5 className="modal-title mb-0">Встановити знижку</h5>
                <div className="font-weight-bold" style={{ fontSize: '0.8rem', color: '#0d6efd', lineHeight: 1.2 }}>
                  Буде застосовано до {selectedCount} товарів
                </div>
              </div>
              <button type="button" className="close" aria-label="Close" onClick={() => !loading && onClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <AdminDiscountForm
                forceDiscount={forceDiscount}
                onForceDiscountChange={onForceDiscountChange}
                discountLevelsList={discountLevelsList}
                selectedDiscountLevel={selectedDiscountLevel}
                onDiscountLevelChange={onDiscountLevelChange}
                discountPercent={discountPercent}
                onDiscountPercentChange={onDiscountPercentChange}
                token={token}
                selectedUser={discountSelectedUser}
                userSearchQuery={discountUserSearchQuery}
                onUserSearchQueryChange={onDiscountUserSearchQueryChange}
                onUserSelect={onDiscountUserSelect}
                onUserClear={onDiscountUserClear}
                disabled={loading}
                forceCheckboxId="bulkOrderForceDiscount"
              />
              {message && (
                <div className="alert alert-success mt-3 mb-0" role="alert">
                  {message}
                </div>
              )}
              {errorMessage && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                  {errorMessage}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                Закрити
              </button>
              <button type="button" className="btn btn-dark" onClick={onApply} disabled={loading}>
                {loading ? 'Застосування…' : 'Застосувати'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkOrderDiscountModal;
